import { render } from "./FormPhotoInsuranceCertificate.vue?vue&type=template&id=7283048a"
import script from "./FormPhotoInsuranceCertificate.vue?vue&type=script&lang=js"
export * from "./FormPhotoInsuranceCertificate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__